import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "./shared";

export default function RelatedArticlesSection({ city, lang, t }) {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/blog/posts?city=${city.slug}&limit=6&lang=${lang}`)
      .then(r => r.json())
      .then(d => setArticles((d.articles || []).slice(0, 4)))
      .catch(() => setArticles([]));
  }, [city.slug, lang]);

  if (articles.length === 0) return null;

  const titleField = lang === "en" ? "title_en" : lang === "tr" ? "title_tr" : "title_ru";
  const excerptField = lang === "en" ? "excerpt_en" : lang === "tr" ? "excerpt_tr" : "excerpt_ru";

  return (
    <section className="bg-[#FAF5EE] py-16 sm:py-24 lg:py-32" data-testid="weddings-related-articles">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-10">
        <SectionHeading
          eyebrow={t.relatedEyebrow}
          title={t.relatedTitle}
          titleAccent={t.relatedTitleAccent}
          subtitle={t.relatedSubtitle}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {articles.map(a => (
            <Link
              key={a.id || a.slug}
              to={`/blog/${a.slug}${lang !== "ru" ? `?lang=${lang}` : ""}`}
              className="group bg-white border border-[#EFE4D2] hover:border-[#C9A87C] rounded-sm p-6 sm:p-7 transition-all duration-500 hover:shadow-[0_18px_45px_-20px_rgba(31,24,21,0.25)]"
              data-testid={`weddings-related-${a.slug}`}
            >
              <p className="text-[10px] tracking-[0.25em] text-[#B8966F] mb-3 font-light">
                {lang === "en" ? `BLOG · ${(city.nameEn || "").toUpperCase()}` : `БЛОГ · ${(city.name || "").toUpperCase()}`}
              </p>
              <h3 className="text-xl sm:text-2xl text-[#1F1815] mb-3 sm:mb-4 leading-snug group-hover:text-[#8B6F47] transition-colors"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
                {a[titleField] || a.title_ru}
              </h3>
              <p className="text-sm text-[#6B5D4F] font-light leading-relaxed mb-4 line-clamp-3">
                {a[excerptField] || a.excerpt_ru}
              </p>
              <span className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.22em] font-medium text-[#8B6F47] group-hover:gap-3 transition-all">
                {lang === "en" ? "READ" : lang === "tr" ? "OKU" : "ЧИТАТЬ"} <ArrowRight className="w-3 h-3" />
              </span>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10 sm:mt-12">
          <Link to={`/blog${lang !== "ru" ? `?lang=${lang}` : ""}`}
                className="inline-flex items-center gap-2 text-[11px] sm:text-[12px] tracking-[0.22em] text-[#8B6F47] hover:text-[#1F1815] font-medium transition"
                data-testid="weddings-related-all">
            {t.relatedAll} <ArrowRight className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </section>
  );
}
